import React from "react";
import { Navigate } from "react-router-dom";
import { useUser } from "@/utils/userContext/UserContext";
import { Role } from "@/utils/models/UserData";

interface RoleProtectedRouteProps {
  children: React.ReactNode;
  allowedRoles: Role[];
  redirectTo?: string;
}

/**
 * Componente que protege rotas baseado na role do usuário.
 * Se o usuário não tiver uma das roles permitidas, redireciona para outra página.
 */
const RoleProtectedRoute: React.FC<RoleProtectedRouteProps> = ({
  children,
  allowedRoles,
  redirectTo = "/dashboard/clientes",
}) => {
  const { userData } = useUser();

  // Se o usuário ainda está carregando (não tem userData), não renderiza nada
  if (!userData) {
    return null;
  }

  // Se o usuário tem auth mas não tem role (usuário antigo), assume OWNER
  // Isso permite que usuários que logaram antes das mudanças continuem funcionando
  const effectiveRole: Role = userData.role ?? "OWNER";

  // Se a role do usuário não está nas roles permitidas, redireciona
  if (!allowedRoles.includes(effectiveRole)) {
    return <Navigate to={redirectTo} replace />;
  }

  return <>{children}</>;
};

export default RoleProtectedRoute;

